import ReactSpeedometer from "react-d3-speedometer"
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

let currentTemp;
export function ISO4406Meter({OilTemp, type}) {

    
    let textColor ="white"

   if(type==="1")
   {
       if(OilTemp>17){
        textColor ="#b71c1c"
       }
    return (

        ISOComponent(OilTemp,14,18,23,textColor)
    )
   }
   else if(type==="2")
   {
    if(OilTemp>16){
        textColor ="#b71c1c"
       }
    return (

        ISOComponent(OilTemp,13,17,21,textColor)
    )
   }
   else if(type==="3"){
    if(OilTemp>14){
        textColor ="#b71c1c"
       }
    return (

        ISOComponent(OilTemp,11,15,19,textColor)
    )
   }
   else if(type==="4"){
    if(OilTemp>23){
        textColor ="#b71c1c"
       }
    return (

        ISOComponent(OilTemp,18,23,30,textColor)
    )
   }

    return (

        null
    )

}

const ISOComponent = (temp,min,mid,max, textColor) => {

  let  SegmentColors=['#9ccc65','#9ccc65','#ffd54f','#ffd54f','#ff8f00','#ff8f00' ]

if(textColor == "#b71c1c"){
       
    SegmentColors=["#b71c1c","#b71c1c","#b71c1c","#b71c1c","#b71c1c","#b71c1c" ] 
}
    return (

      
        <ReactSpeedometer
        style={{opacity:"1"}}
        width={120}
        height={100}
        ringWidth={8}
        needleHeightRatio={0.6}
        
            forceRender={false}
            // maxSegmentLabels={1}
            customSegmentStops={[0,min,mid,max]}
             segmentColors={SegmentColors}
       
            
              needleColor={"white"}
              currentValueText={'${value}'}
              minValue={0}
              maxValue={max}
              value={temp}
              valueTextFontSize={'25px'}
              paddingVertical={10}
              textColor={"white"}
              />
             
              )
              
            }              